export const getTooltipClasses = (
  baseClass: string,
  position: string,
  disableTopStyles?: boolean,
  additionalClasses?: string
) => {
  const positionClass =
    disableTopStyles && position === "top" ? `${baseClass}OnlyTop` : position;

  return `${baseClass} ${positionClass} ${additionalClasses || ""}`.trim();
};
